import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
	  pathName: "",
  },
  mutations: {
	   savePath(state,pathName){
	              state.pathName = pathName;
	     }
  },
  actions: {
  },
  modules: {
  }
})
